import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const FechaIngresoFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, setFieldValue }) => {
  const onInputChange = React.useCallback(
    e => {
      handleChange(e)
      const nuevaFecha = e.target.value
      setFieldValue('fechaSalida', nuevaFecha)
    },
    [handleChange, setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='FEC. INGRESO' htmlFor='date-fechaIngreso' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaIngreso'>
          {({ field }) => (
            <Form.InputDate {...field} id='date-fechaIngreso' onChange={onInputChange} disabled={fIsSubmitting} isInvalid={iTouched && iError} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaIngresoFormGroup)
